import Cookies from "js-cookie";
import { encrypt, decrypt } from "crypto-utils-react";

const SECRET_KEY =
  import.meta.env.VITE_APP_API_SECRET_KEY || "fallback_secret_key";

// --- Local Storage ---

export const setLocalItem = async (key: string, value: any) => {
  const encrypted = await encrypt(value, SECRET_KEY);
  localStorage.setItem(key, encrypted);
};

export const getLocalItem = async (key: string) => {
  const encrypted = localStorage.getItem(key);
  if (!encrypted) return null;
  return await decrypt(encrypted, SECRET_KEY);
};

export const removeLocalItem = (key: string) => {
  localStorage.removeItem(key);
};

// --- Session Storage ---

export const setSessionItem = async (key: string, value: any) => {
  const encrypted = await encrypt(value, SECRET_KEY);
  sessionStorage.setItem(key, encrypted);
};

export const getSessionItem = async (key: string) => {
  const encrypted = sessionStorage.getItem(key);
  if (!encrypted) return null;
  return await decrypt(encrypted, SECRET_KEY);
};

export const removeSessionItem = (key: string) => {
  sessionStorage.removeItem(key);
};

// --- Cookies (using js-cookie) ---

export const setCookieItem = async (
  key: string,
  value: any,
  options?: Cookies.CookieAttributes,
) => {
  const encrypted = await encrypt(value, SECRET_KEY);
  Cookies.set(key, encrypted, { secure: true, sameSite: "strict", ...options });
};

export const getCookieItem = async (key: string) => {
  const encrypted = Cookies.get(key);
  if (!encrypted) return null;
  return await decrypt(encrypted, SECRET_KEY);
};

export const removeCookieItem = (
  key: string,
  options?: Cookies.CookieAttributes,
) => {
  Cookies.remove(key, options);
};

// --- Legacy support and JWT helpers (Now pointing to Session Storage) ---

export const setItem = setSessionItem;
export const getItem = getSessionItem;
export const removeItem = removeSessionItem;
export const getToken = getSessionItem;

export const decodeJwt = (token: string) => {
  try {
    const base64Url = token.split(".")[1];
    if (!base64Url) return null;
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join(""),
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error("Invalid token", error);
    return null;
  }
};

export const tokenData = async (key: string = "token") => {
  const token = await getItem(key);
  if (!token) return null;
  const decodeToken = decodeJwt(token);
  return decodeToken;
};

export { encrypt, decrypt };
